import mocks from './mocks';

const response = (status, body) =>
  new Response(
    new Blob([JSON.stringify(body)], {
      type: 'application/json'
    }),
    {
      status
    }
  );

export const fetchMock = (url, { body = null, ...otherProps }) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      let mock = mocks(url, {
        ...otherProps,
        body: JSON.parse(body)
      });

      if (mock) {
        resolve(response(200, mock));
      }
      reject(
        response(500, {
          message: 'Não foi criado mock para ' + url
        })
      );
    }, 1000);
  });

export default fetch;



// WEBPACK FOOTER //
// ./src/utils/request.js